import React from "react";
import { CmmOrderTableRowData } from "../../../../../../data-model/cmmOrderTableRowData";

interface MedicationHeaderProps {
  data: CmmOrderTableRowData;
}

export const MedicationHeader: React.FC<MedicationHeaderProps> = ({ data }) => {
  return (
    <div className="flex w-full flex-col gap-2 rounded-b-md border-b-2 border-primaryGray-15 bg-primaryGray-16 p-3">
      <div className="text-sm font-bold">{data?.drugName || "--"}</div>
      <div className="text-sm text-primaryGray-6">
        {data?.prescriptionData?.prescription_date || "--"}
        &nbsp;&nbsp;<span>&#8226;</span>&nbsp;&nbsp;
        {data?.prescriptionData?.drug_name || "--"}
      </div>
    </div>
  );
};
